/**
 * SSR-safe utilities for browser environment checks
 */

/**
 * Check if code is running in a browser environment
 */
export function isBrowser(): boolean {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

/**
 * Check if code is running on the server (SSR)
 */
export function isServer(): boolean {
  return !isBrowser();
}

/**
 * Safe window accessor that returns undefined during SSR
 */
export function getWindow(): Window | undefined {
  return typeof window !== 'undefined' ? window : undefined;
}

/**
 * Safe document accessor that returns undefined during SSR
 */
export function getDocument(): Document | undefined {
  return typeof document !== 'undefined' ? document : undefined;
}

/**
 * Safe navigator accessor that returns undefined during SSR
 */
export function getNavigator(): Navigator | undefined {
  return typeof navigator !== 'undefined' ? navigator : undefined;
}